import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import CountUp from 'react-countup';

const Banner = ({ content }) => {
    const countDelay = 0;
    const countDuration = 0.6;
    const [leftRate, setLeftRate] = useState(0);
    const [rightRate, setRightRate] = useState(0);

    useEffect(() => {
        const left = Number(content?.voteList?.campSummaryList?.[0]?.currentRate) || 0;
        const right = Number(content?.voteList?.campSummaryList?.[1]?.currentRate) || 0;

        const raf = requestAnimationFrame(() => {
            setLeftRate(left);
            setRightRate(right);
        });

        return () => cancelAnimationFrame(raf);
    }, [content]);

    const isEnd = content?.voteList?.overview?.isEnd;

    return (
        <div className={styles.banner}>
            <div className={styles.bannerTitle}>{isEnd ? '席位开票结果' : '实时席位统计'}</div>
            <div className={styles.bannerVote}>
                <div className={styles.bannerVoteL}>
                    <CountUp start={0} end={content?.voteList?.campSummaryList?.[0]?.currentSeats} duration={countDuration} delay={countDelay} />
                </div>
                <div className={styles.bannerVoteC}>{content?.voteList?.overview?.majoritySeats}即过半数</div>
                <div className={styles.bannerVoteR}>
                    <CountUp start={0} end={content?.voteList?.campSummaryList?.[1]?.currentSeats} duration={countDuration} delay={countDelay} />
                </div>
            </div>
            <div className={styles.bannerBar}>
                <div className={styles.bannerBarBox}>
                    <div className={styles.bannerBarColor} />
                    <div className={styles.bannerBarLText}>{content?.voteList?.campSummaryList?.[0]?.campName}</div>
                    <div className={styles.bannerBarRText}>{content?.voteList?.campSummaryList?.[1]?.campName}</div>
                    <div className={styles.bannerBarL} style={{ width: `${leftRate}%` }} />
                    <div className={styles.bannerBarR} style={{ width: `${rightRate}%` }} />
                </div>
                <div className={styles.bannerBarC} />
            </div>
        </div>
    );
};

Banner.propTypes = {
    content: PropTypes.object,
};

export default Banner;
